import Modbury61 from '../Modbury 6/Type 6 (1).webp'
import Modbury62 from '../Modbury 6/Type 6 (2).webp'
import Modbury63 from '../Modbury 6/Type 6 (3).webp'
import Modbury64 from '../Modbury 6/Type 6 (4).webp'
import Modbury65 from '../Modbury 6/Type 6 (5).webp'
import Modbury66 from '../Modbury 6/Type 6 (6).webp'
import Modbury67 from '../Modbury 6/Type 6 (7).webp'
import Modbury68 from '../Modbury 6/Type 6 (8).webp'
import Modbury69 from '../Modbury 6/Type 6 (9).webp'


const Modbury6images =[
Modbury61,Modbury62,Modbury63,Modbury64,Modbury65,Modbury66,Modbury67,Modbury68,Modbury69
]

export default Modbury6images;